import React from 'react';
import PropTypes from 'prop-types';
import GridItem from './GridItem';

const Grid = ({ fields, selectedIndex, statePosition, selectionHandler, decrementHandler, incrementHandler, valueHandler, values, error, disabled = false, refersTo = null, className = '', onFocus, onBlur }) => {

	return (

		<div className="grid">
			{fields.map((field, index) => {
				const openLogic = fields.length === 1 ? true :
				selectedIndex === index ? true :
				field.cost_basis !== 'unit' ? true : false;
				return (<GridItem
					key={index}
					open={openLogic}
					selectionHandler={selectionHandler}
					index={index}
					value={values[index] === undefined ? 0 : values[index]}
					title={field.title}
					subTitle={field.sub_title}
					costBasis={field.cost_basis}
					content={field.content}
					image={field.image}
					statePosition={statePosition}
					changeHandler={valueHandler}
					decrementHandler={decrementHandler}
					incrementHandler={incrementHandler} />)
			})}
		</div>
	);
};

Grid.propTypes = {
	fields: PropTypes.array.isRequired,
	selectedIndex: PropTypes.number,
	selectedValue: PropTypes.number,
	selectionHandler: PropTypes.func.isRequired,
	valueHandler: PropTypes.func.isRequired,
	incrementHandler: PropTypes.func.isRequired,
	decrementHandler: PropTypes.func.isRequired,
	error: PropTypes.string,
	refersTo: PropTypes.func,
	onBlur: PropTypes.func,
	onFocus: PropTypes.func
}

export default Grid;



// WEBPACK FOOTER //
// ./src/components/step/Grid.js